import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import css from './PrivacyPolicy.css';
import { FormattedMessage } from 'react-intl';

const PrivacyPolicy = props => {
  const { rootClassName, className } = props;
  const classes = classNames(rootClassName || css.root, className);

  // prettier-ignore
  return (
    <div className={classes}>
      {/* <p className={css.lastUpdated}>Last updated: October 30, 2017</p> */}
      <h1 className={css.heading}>
        <FormattedMessage id="PrivacyPolicyPage.heading" />
      </h1>
      <p>
        <FormattedMessage id="TermsOfServicePage.p0.1" />
      </p>
      <p>
        <FormattedMessage id="TermsOfServicePage.p0.2" />
      </p>
      <p>
        <FormattedMessage id="TermsOfServicePage.p0.3" />
      </p>

      <ol>
        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p1.1.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p1.1.2.name" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p1.1.2.street" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p1.1.2.city" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p1.1.2.mobile" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p1.1.2.email" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p1.1.2.website" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline2" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline2-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p2.1.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline2-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p2.2.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p2.2.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p2.2.3" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p2.2.4" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p2.2.5" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline2-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p2.3.1" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline3" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline3-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p3.1.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p3.1.2" />
            <ul className={css.circle}>
              <li>
                <FormattedMessage id="TermsOfServicePage.p3.1.2.ip" />
              </li>
              <li>
                <FormattedMessage id="TermsOfServicePage.p3.1.2.dateTime" />
              </li>
              <li>
                <FormattedMessage id="TermsOfServicePage.p3.1.2.timeZone" />
              </li>
              <li>
                <FormattedMessage id="TermsOfServicePage.p3.1.2.dateTime" />
              </li>
              <li>
                <FormattedMessage id="TermsOfServicePage.p3.1.2.contentRequest" />
              </li>
              <li>
                <FormattedMessage id="TermsOfServicePage.p3.1.2.access" />
              </li>
              <li>
                <FormattedMessage id="TermsOfServicePage.p3.1.2.amountData" />
              </li>
              <li>
                <FormattedMessage id="TermsOfServicePage.p3.1.2.webPageRequest" />
              </li>
              <li>
                <FormattedMessage id="TermsOfServicePage.p3.1.2.browser" />
              </li>
              <li>
                <FormattedMessage id="TermsOfServicePage.p3.1.2.operatingSystem" />
              </li>
              <li>
                <FormattedMessage id="TermsOfServicePage.p3.1.2.language" />
              </li>
            </ul>
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p3.1.3" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p3.1.4" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline3-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p3.2.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p3.2.2" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline3-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p3.3.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline3-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p3.4.1" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline4" />
          </h2>
          <ul className={css.alphabetic}>
            <li>
              <h2>
                <FormattedMessage id="TermsOfServicePage.headline4-1" />
              </h2>
            </li>

            <p>
              <FormattedMessage id="TermsOfServicePage.p4.1.1" />
            </p>
            <h2>
              <FormattedMessage id="TermsOfServicePage.headline4-1-1" />
            </h2>
            <h2>
              <FormattedMessage id="TermsOfServicePage.headline4-1-2" />
            </h2>
            <p>
              <FormattedMessage id="TermsOfServicePage.p4.1.2.1" />
            </p>
            <h2>
              <FormattedMessage id="TermsOfServicePage.headline4-1-3" />
            </h2>
            <p>
              <FormattedMessage id="TermsOfServicePage.p4.1.3.1.name" />
              <br />
              <FormattedMessage id="TermsOfServicePage.p4.1.3.2.provider" />
              <br />
              <FormattedMessage id="TermsOfServicePage.p4.1.3.3.purpose" />
              <br />
              <FormattedMessage id="TermsOfServicePage.p4.1.3.4.cookieName" />
              <br />
              <FormattedMessage id="TermsOfServicePage.p4.1.3.5.cookieDuration" />
            </p>
            <h2>
              <FormattedMessage id="TermsOfServicePage.headline4-1-4" />
            </h2>
            <p>
              <FormattedMessage id="TermsOfServicePage.p4.1.4.1" />
            </p>
            <h2>
              <FormattedMessage id="TermsOfServicePage.headline4-1-5" />
            </h2>
            <p>
              <FormattedMessage id="TermsOfServicePage.p4.1.5.1.name" />
              <br />
              <FormattedMessage id="TermsOfServicePage.p4.1.5.2.provider" />
              <br />
              <FormattedMessage id="TermsOfServicePage.p4.1.5.3.purpose" />
              <br />
              <FormattedMessage id="TermsOfServicePage.p4.1.5.4.privacyPolicy" />
              <br />
              <FormattedMessage id="TermsOfServicePage.p4.1.5.5.cookieName" />
              <br />
              <FormattedMessage id="TermsOfServicePage.p4.1.5.6.cookieDuration" />
            </p>
            <p>
              <FormattedMessage id="TermsOfServicePage.p4.1.2" />
            </p>
            <p>
              <FormattedMessage id="TermsOfServicePage.p4.1.3" />
            </p>
            <p>
              <FormattedMessage id="TermsOfServicePage.p4.1.4" />
            </p>
            <li>
              <h2>
                <FormattedMessage id="TermsOfServicePage.headline4-2" />
              </h2>
            </li>
            <p>
              <FormattedMessage id="TermsOfServicePage.p4.2.1" />
            </p>
            <li>
              <h2>
                <FormattedMessage id="TermsOfServicePage.headline4-3" />
              </h2>
            </li>
            <p>
              <FormattedMessage id="TermsOfServicePage.p4.3.1" />
            </p>
            <li>
              <h2>
                <FormattedMessage id="TermsOfServicePage.headline4-4" />
              </h2>
            </li>
            <p>
              <FormattedMessage id="TermsOfServicePage.p4.4.1" />
            </p>
          </ul>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline5" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline5-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p5.1.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p5.1.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p5.1.3" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline5-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p5.2.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline5-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p5.3.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline5-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p5.4.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline5-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p5.5.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p5.5.2" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline6" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline6-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p6.1.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline6-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p6.2.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline6-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p6.3.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline6-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p6.4.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p6.4.2" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline6-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p6.5.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p6.5.2" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline7" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline7-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p7.1.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline7-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p7.2.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline7-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p7.3.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline7-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p7.4.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline7-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p7.5.1" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline8" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline8-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p8.1.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p8.1.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p8.1.3" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline8-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p8.2.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p8.2.2" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline8-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p8.3.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p8.3.2" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline8-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p8.4.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline8-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p8.5.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p8.5.2" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline9" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline9-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p9.1.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline9-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p9.2.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline9-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p9.3.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline9-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p9.4.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline9-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p9.5.1" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline10" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline10-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p10.1.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline10-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p10.2.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline10-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p10.3.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline10-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p10.4.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline10-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p10.5.1" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline11" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline11-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.1.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.1.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.1.3" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.1.4" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.1.5" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.1.6" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline11-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.2.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline11-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.3.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline11-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.4.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline11-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.5.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.5.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p11.5.3" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline12" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline12-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.1.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.1.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.1.3" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.1.4" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.1.5" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline12-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.2.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.2.2" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline12-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.3.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.3.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.3.3" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline12-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.4.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline12-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p12.5.1" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline13" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline13-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p13.1.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p13.1.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p13.1.3" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p13.1.4" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline13-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p13.2.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline13-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p13.3.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline13-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p13.4.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline13-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p13.5.1" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline14" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline14-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p14.1.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline14-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p14.2.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline14-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p14.3.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline14-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p14.4.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline14-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p14.5.1" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline15" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline15-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p15.1.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline15-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p15.2.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline15-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p15.3.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p15.3.2" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline15-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p15.4.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p15.4.2" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline15-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p15.5.1" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline16" />
          </h2>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline16-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p16.1.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p16.1.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p16.1.3" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline16-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p16.2.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline16-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p16.3.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p16.3.2" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline16-4" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p16.4.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline16-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p16.5.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p16.5.2" />
          </p>
        </li>

        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17-1" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.1.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.1.2" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.1.2.1" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.1.2.2" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.1.2.3" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.1.2.4" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.1.2.5" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.1.2.6" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.1.2.7" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.1.2.8" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.1.3" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17-2" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.2.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17-3" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.3.1" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.3.1.1" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.3.1.2" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.3.1.3" />
            <br />
            <FormattedMessage id="TermsOfServicePage.p17.3.1.4" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.3.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.3.3" />
          </p>

          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17-4" />
          </h2>
          <ul className={css.alphabetic}>
            <li>
              <h2>
                <FormattedMessage id="TermsOfServicePage.headline17-4-1" />
              </h2>
              <p>
                <FormattedMessage id="TermsOfServicePage.p17.4.1.1" />
                <br />
                <FormattedMessage id="TermsOfServicePage.p17.4.1.1.1" />
                <br />
                <FormattedMessage id="TermsOfServicePage.p17.4.1.1.2" />
                <br />
                <FormattedMessage id="TermsOfServicePage.p17.4.1.1.3" />
                <br />
                <FormattedMessage id="TermsOfServicePage.p17.4.1.1.4" />
                <br />
                <FormattedMessage id="TermsOfServicePage.p17.4.1.1.5" />
                <br />
                <FormattedMessage id="TermsOfServicePage.p17.4.1.1.6" />
              </p>
            </li>
            <li>
              <h2>
                <FormattedMessage id="TermsOfServicePage.headline17-4-2" />
              </h2>
              <p>
                <FormattedMessage id="TermsOfServicePage.p17.4.2.1" />
              </p>
            </li>
            <li>
              <h2>
                <FormattedMessage id="TermsOfServicePage.headline17-4-3" />
              </h2>
              <p>
                <FormattedMessage id="TermsOfServicePage.p17.4.3.1" />
                <br />
                <FormattedMessage id="TermsOfServicePage.p17.4.3.1.1" />
                <br />
                <FormattedMessage id="TermsOfServicePage.p17.4.3.1.2" />
                <br />
                <FormattedMessage id="TermsOfServicePage.p17.4.3.1.3" />
                <br />
                <FormattedMessage id="TermsOfServicePage.p17.4.3.1.4" />
                <br />
                <FormattedMessage id="TermsOfServicePage.p17.4.3.1.5" />
              </p>
            </li>
          </ul>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17-5" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.5.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.5.2" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17-6" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.6.1" />
            <FormattedMessage id="TermsOfServicePage.p17.6.1.1" />
            <FormattedMessage id="TermsOfServicePage.p17.6.1.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.6.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.6.3" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17-6" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.6.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17-7" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.7.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.7.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.7.3" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.7.4" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.7.5" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17-8" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.8.1" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17-9" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.9.1" />
            <FormattedMessage id="TermsOfServicePage.p17.9.1.1" />
            <FormattedMessage id="TermsOfServicePage.p17.9.1.2" />
            <FormattedMessage id="TermsOfServicePage.p17.9.1.3" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.9.2" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.9.3" />
          </p>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline17-10" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.10.1" />
          </p>
          <p>
            <FormattedMessage id="TermsOfServicePage.p17.10.2" />
          </p>
        </li>
        <li>
          <h2>
            <FormattedMessage id="TermsOfServicePage.headline18" />
          </h2>
          <p>
            <FormattedMessage id="TermsOfServicePage.p18.1" />
          </p>
        </li>
      </ol>
    </div>
  );
};

PrivacyPolicy.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

PrivacyPolicy.propTypes = {
  rootClassName: string,
  className: string,
};

export default PrivacyPolicy;
